import { registerTourPage } from '@/composables/tour/tourRegistry';
import { introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-course-registration-view', {
  key: 'admin-course-registration-view',
  label: 'Course Registration View',
  getSteps: () => [
    introStep({
      title: 'Student\'s Course Registration',
      content:
        'Every course this student has registered for, grouped by session/semester. Use the academic calendar filter to focus on a specific term, or click "Admin Submit Course" to register them on their behalf.',
    }),
  ],
});

registerTourPage('admin-course-registration-submit', {
  key: 'admin-course-registration-submit',
  label: 'Admin Submit Course Registration',
  getSteps: () => [
    introStep({
      title: 'Register on Behalf of a Student',
      content:
        'Walk through the steps: pick the session, then either auto-pick from the programme curriculum or select courses manually. Submit when complete to record the registration as if the student did it themselves.',
    }),
  ],
});
